import client from '@stores/apollo'
import gql from 'graphql-tag'
import { INeighborhoodImportFailed } from '@api'
import { NeighborhoodImportFailedFragment } from '@api/fragments'

export default function failed(
  id: string
): Promise<{ failed: INeighborhoodImportFailed[] | null }> {
  return client.gql.query({ query, variables: { id } }).then(
    ({
      data: {
        node: { failed },
      },
    }: {
      data: { node: { failed: INeighborhoodImportFailed[] | null } }
    }) => ({ failed })
  )
}

const query = gql`
  query importFailed($id: ID!) {
    node(id: $id) {
      ... on EmployeesNeighborhoodsImport {
        failed {
          ...NeighborhoodImportFailedFragment
        }
      }
    }
  }
  ${NeighborhoodImportFailedFragment}
`
